export enum TripCategory {
  International = "International",
  Domestic = "Domestic",
  Inbound = "Inbound",
}

export enum PlanType {
  IndividualPlan = "Individual",
  FamilyPlan = "Family",
  GroupPlan = "Group",
}

export enum TripType {
  SingleTrip = "Single Trip",
  MultiTrip = "Multi Trip",
}

export enum ModeOfTravel {
  ViaAir,
  ViaLand,
}

export enum TravelPurpose {
  Business = "Business",
  Leisure = "Leisure",
  ShortTermStudy = "Short-term",
  VisitRelatives = "Visit Relatives",
}

export type TripApplication = {
  category: TripCategory;
  tripType: TripType;
  planType?: PlanType;
  purpose?: TravelPurpose;
  isReturningToPhilippines?: boolean;
  startTrip?: string;
  destination?: string[];
  endTrip?: string;
  startDate?: Date;
  endDate?: Date;
  modeOfTravel?: ModeOfTravel;
};

export enum CoverageType {
  myself = "myself",
  SomeoneElse = "someone-else",
}
